export const common = {
  // Navbar
  nav_inicio: 'Home',
  nav_sobre_nosotros: 'About Us',
  nav_productos: 'Products',
  nav_testimonios: 'Testimonials',
  nav_contacto: 'Contact',
  
  // Hero
  hero_title: 'Mexican, Honduran, Salvadoran and Nicaraguan Products Store in Indianapolis',
  hero_subtitle: 'Discover the authentic essence of Mexico, Honduras, El Salvador and Nicaragua in the heart of Indianapolis. Wide variety of Latin products, many of them hard to find in other stores.',
  hero_whatsapp: 'Message us on WhatsApp',
  hero_location: 'View Location',
  hero_authentic: 'Authentic Products',
  hero_prices: 'Best Prices',
  hero_service: 'Close Attention',
  hero_shipping: 'Box Shipping',
  
  // About
  about_badge: 'About Us',
  about_title: 'Your',
  about_title_highlight: 'Central American Products',
  about_title_suffix: 'Store in Indianapolis',
  about_p1: 'We are a store specialized in Mexican, Honduran, Salvadoran and Nicaraguan products located in Indianapolis. We bring authentic products directly from Central America so you can enjoy the flavors of your homeland.',
  about_p2: 'We handle a wide variety of Central American products: traditional candies, snacks, groceries, typical beverages, artisan sauces, chiles, condiments and much more. Many of our products are hard to find in other stores in the area.',
  about_p3: 'We offer some of the best prices in the market because we want the entire Latino community to have access to quality products at fair prices. Our service is close, friendly and familiar - we speak Spanish and English.',
  about_p4: 'We are located in a quiet and family-friendly area of Indianapolis, ideal to visit with your whole family. When you enter our store, you will feel like you are in a store in your country. We look forward to welcoming you!',
  about_stat_products: 'Products',
  about_stat_countries: 'Countries',
  about_stat_authentic: 'Authentic',
  
  // Products
  products_badge: 'Our Products',
  products_title: 'Authentic Products from Mexico and Central America',
  products_subtitle: 'Discover our wide selection of Mexican, Honduran, Salvadoran and Nicaraguan products. Everything you need to prepare your favorite dishes is here.',
  products_cat1_title: 'Tortillas and Masa',
  products_cat1_desc: 'Fresh corn and flour tortillas, masa for tamales, totopos, and authentic tortilla chips made in the traditional style.',
  products_cat2_title: 'Chiles and Sauces',
  products_cat2_desc: 'Wide variety of dried and fresh chiles (jalapeño, serrano, habanero, chipotle), artisan hot sauces, and traditional moles from Oaxaca.',
  products_cat3_title: 'Beans and Grains',
  products_cat3_desc: 'Black beans, pinto beans, bayo beans, lentils, Mexican rice, and high-quality basic grains of Latin American cuisine.',
  products_cat4_title: 'Spices and Seasonings',
  products_cat4_desc: 'Cumin, Mexican oregano, cinnamon, achiote, epazote, and authentic spice blends to flavor your favorite dishes.',
  products_cat5_title: 'Candies and Snacks',
  products_cat5_desc: 'Typical Mexican candies (mazapán, tamarind, pulparindo), Nicaraguan boquitas, Salvadoran churros, and traditional Honduran snacks.',
  products_cat6_title: 'Seasonal Products',
  products_cat6_desc: 'Pan de muerto, rosca de reyes, Christmas tamales, pozole ingredients, and special products for traditional Mexican and Central American celebrations throughout the year.',
  products_cta_title: 'Can\'t Find What You\'re Looking For?',
  products_cta_subtitle: 'We have hundreds more products in our store. Visit us or contact us to check availability of specific products.',
  products_cta_contact: 'Contact Us',
  products_cta_whatsapp: 'WhatsApp',
  
  // Contact
  contact_badge: 'Contact and Location',
  contact_title: 'Visit Us or Contact Us',
  contact_subtitle: 'We are here to serve you. Come meet us or write to us, we will be happy to assist you.',
  contact_info_title: 'Contact Information',
  contact_address: 'Address',
  contact_address_line1: 'Tienda La Bonita Market',
  contact_address_line2: '4051 Carson Ave',
  contact_address_line3: 'Indianapolis, IN 46227',
  contact_hours: 'Business Hours',
  contact_hours_time: 'Monday to Sunday: 8:00 AM - 10:30 PM',
  contact_phone: 'Phone',
  contact_email: 'Email',
  contact_whatsapp_btn: 'Send WhatsApp Message',
  contact_form_title: 'Send Us a Message',
  contact_name: 'Full Name',
  contact_name_placeholder: 'Your name',
  contact_email_label: 'Email',
  contact_email_placeholder: 'your@email.com',
  contact_phone_label: 'Phone',
  contact_phone_placeholder: '(123) 456-7890',
  contact_message: 'Message',
  contact_message_placeholder: 'How can we help you?',
  contact_send: 'Send Message',
  contact_sending: 'Sending...',
  contact_success: 'Message sent successfully! We will contact you soon.',
  contact_error: 'There was an error sending the message. Please try again.',
  contact_form_name: 'Full Name',
  contact_form_name_placeholder: 'Your name',
  contact_form_email: 'Email',
  contact_form_email_placeholder: 'your@email.com',
  contact_form_message: 'Message',
  contact_form_message_placeholder: 'How can we help you?',
  contact_form_max_chars: 'Maximum 500 characters',
  contact_form_submit: 'Send Message',
  contact_form_sending: 'Sending...',
  contact_form_success: 'Message sent successfully! We will contact you soon.',
  contact_form_error: 'There was an error sending the message. Please try again.',
  contact_final_title: 'Visit Us and Experience a Mexican Store in Indianapolis',
  contact_final_subtitle: 'We look forward to welcoming you. Come discover all the Mexican products we have for you and your family. You will feel at home!',
  contact_final_location: 'View Location',
  contact_final_whatsapp: 'Contact via WhatsApp',
  
  // Testimonials
  testimonials_badge: 'TESTIMONIALS',
  testimonials_title: 'What Our',
  testimonials_title_highlight: 'Customers Say',
  testimonials_subtitle: 'Our customers\' satisfaction is our greatest reward. Read what the families who visit us think.',
  testimonials_cta_text: 'Want to be part of our family of satisfied customers?',
  testimonials_cta_button: 'Contact Us Now',
  
  // Why Choose Us
  why_badge: 'Why Choose Us',
  why_title: 'Your Best Choice for',
  why_title_highlight: 'Central American Products',
  why_subtitle: 'We are more than a store, we are a little piece of Mexico, Honduras, El Salvador and Nicaragua in Indianapolis.',
  why_reason1_title: 'Hard-to-Find Products',
  why_reason1_desc: 'We bring authentic products directly from Mexico, Honduras, El Salvador and Nicaragua that you won\'t easily find in other Indianapolis stores.',
  why_reason2_title: 'Fair and Competitive Prices',
  why_reason2_desc: 'We offer excellent prices so that the entire Latino community has access to quality products without overspending. Some of the best prices on the market.',
  why_reason3_title: 'Close and Familiar Service',
  why_reason3_desc: 'Friendly service in Spanish and English. We treat you like family because we understand how important it is to feel at home. Always ready to help you.',
  why_reason4_title: 'Shipping with Paquetería Hernández',
  why_reason4_desc: 'We ship boxes to Mexico, Guatemala, El Salvador and Honduras quickly and safely. We connect your home with your country with real-time tracking and insurance included.',
  why_additional_title: 'Over 500 Products from 4 Countries',
  why_additional_subtitle: 'Our store has a wide variety of authentic products from Mexico, Honduras, El Salvador and Nicaragua. From basic groceries to special products that will make you feel at home.',
  why_country_mexico: 'Mexico',
  why_country_honduras: 'Honduras',
  why_country_salvador: 'El Salvador',
  why_country_nicaragua: 'Nicaragua',
  
  // Footer
  footer_about_title: 'About Us',
  footer_about_text: 'Your trusted store for Mexican, Honduran, Salvadoran and Nicaraguan products in Indianapolis.',
  footer_quick_links: 'Quick Links',
  footer_contact_title: 'Contact',
  footer_hours_title: 'Hours',
  footer_hours_time: 'Monday to Sunday: 8:00 AM - 10:30 PM',
  footer_rights: 'All rights reserved.',
  footer_powered: 'Powered by Readdy',
  
  // Grand Opening
  grand_opening_badge: 'GRAND OPENING!',
  grand_opening_title: 'Celebrating the Opening of Our New Location!',
  grand_opening_subtitle: '🎉 SPECIAL 🎊',
  grand_opening_subtitle2: 'DISCOUNTS',
  grand_opening_limited: 'LIMITED TIME!',
  grand_opening_exclusive: 'EXCLUSIVE Offers for in-person purchases',
  grand_opening_description: 'Visit us at our new location and take advantage of these incredible discounts',
  grand_opening_location: 'VIEW LOCATION',
  grand_opening_offers: 'CHECK OFFERS',

  // Shipping Section
  shipping_badge: 'SHIPPING SERVICE',
  shipping_title: 'Safe Shipping with',
  shipping_title_highlight: 'Hernández Courier',
  shipping_subtitle: 'We connect your home with Central America quickly and reliably',
  shipping_mexico: 'Mexico',
  shipping_guatemala: 'Guatemala',
  shipping_salvador: 'El Salvador',
  shipping_honduras: 'Honduras',
  shipping_available: 'Available',
  shipping_days: 'days',
  shipping_feature1_title: 'Insurance Included',
  shipping_feature1_desc: 'All boxes travel protected with basic insurance at no additional cost',
  shipping_feature2_title: 'Real-Time Tracking',
  shipping_feature2_desc: 'Monitor your shipment from departure to arrival at its destination',
  shipping_feature3_title: 'Professional Packing',
  shipping_feature3_desc: 'Free advice to properly pack your products',
  shipping_cta: 'Get My Shipping Quote Now',
};
